import React, { useEffect } from 'react'

function FloatingShapes() {
  useEffect(() => {
    const handleMouseMove = (e) => {
      const shapes = document.querySelectorAll('.floating-shape')
      const x = e.clientX / window.innerWidth
      const y = e.clientY / window.innerHeight
      
      shapes.forEach((shape, index) => {
        const speed = 0.5 + (index * 0.2)
        const xOffset = (x - 0.5) * speed * 20
        const yOffset = (y - 0.5) * speed * 20
        
        shape.style.transform = `translate(${xOffset}px, ${yOffset}px)`
      })
    }

    document.addEventListener('mousemove', handleMouseMove)
    
    return () => {
      document.removeEventListener('mousemove', handleMouseMove)
    }
  }, [])

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      <div className="floating-shape shape-1 animate-float" />
      <div className="floating-shape shape-2 animate-float" />
      <div className="floating-shape shape-3 animate-float" />
    </div>
  )
}

export default FloatingShapes